import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { ExternalLink } from 'lucide-react';
import { tx } from '@/translations/translations';

const stores = [
  {
    name: 'Tel Aviv Store',
    logo: '/logos/stores/tel-aviv-store.png',
    website: 'https://telavivstore.mx',
    label: 'telavivstore.mx'
  },
  {
    name: 'Kosher Click',
    logo: '/logos/stores/kosher-click.png',
    website: 'https://linktr.ee/kosher.click',
    label: 'Linktree'
  },
  {
    name: 'Kosher Prime',
    logo: '/logos/stores/kosher-prime.png',
    website: 'https://whatsapp.com/channel/0029Vb7v8DyHgZWb0OtORo37',
    label: 'WhatsApp'
  },
  {
    name: 'Judaica Plus',
    logo: '/logos/stores/judaica-plus.png',
    website: 'https://www.instagram.com/judaicaplus',
    label: '@judaicaplus'
  },
  {
    name: 'Shely Suits',
    logo: '/logos/stores/shely-suits.png',
    website: 'https://wa.link/8o5uix',
    label: 'WhatsApp'
  }
];

const StoresSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-12 bg-slate-900">
      <div className="max-w-4xl mx-auto px-4">
        <p className="text-center text-sm text-slate-400 uppercase tracking-widest mb-8">
          {tx(language, 'Búscanos en', 'Find us at', 'מצאו אותנו ב')}
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
          {stores.map((store) => (
            <a
              key={store.name}
              href={store.website || '#'}
              target={store.website ? '_blank' : '_self'}
              rel="noopener noreferrer"
              className="flex flex-col items-center gap-3 group"
              data-testid={`store-${store.initials}`}
            >
              <div className="w-20 h-20 rounded-xl overflow-hidden shadow-lg group-hover:scale-110 transition-transform bg-white flex items-center justify-center p-1">
                <img src={store.logo} alt={store.name} className="w-full h-full object-contain" />
              </div>
              <div className="text-center">
                <p className="text-white text-sm font-medium">{store.name}</p>
                {store.label && (
                  <p className="text-cyan-400 text-xs flex items-center gap-1 justify-center mt-0.5">
                    {store.label} <ExternalLink className="w-3 h-3" />
                  </p>
                )}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoresSection;
